import { useRef, useState, useMemo } from 'react'
import {
  Card,
  Typography,
  Stack,
  ImageList,
  ImageListItem,
  ListSubheader,
  ImageListItemBar,
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  AvatarGroup,
  Tooltip,
  Avatar,
  Snackbar,
  IconButton,
  makeStyles,
  Skeleton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { ThumbUpAltOutlined, ThumbDownOffAltOutlined, CancelOutlined, Link, Notes, Description, PictureAsPdf, CalendarToday, Event
} from '@material-ui/icons'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import EditIcon from '@material-ui/icons/Edit'
import { sentenceCase } from 'change-case'
import moment from 'moment'
import Scrollbar from 'src/components/Scrollbar'
import {
  ref as imageref,
  uploadBytesResumable,
  getDownloadURL,
} from '@firebase/storage'
import { storage } from 'src/firebase/firebase'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import axios from 'axios'
import { LoadingButton } from '@material-ui/lab'
import { UserMoreMenu } from '../user/list'
import Label from 'src/components/Label'
import Modal from '../blog/ProjectModel'
import { AccountNotifications } from '../user/account'
import { empty } from 'src/Helpers/Common'
import { Icon } from '@iconify/react'
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined';
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined';
import { DialogAnimate } from 'src/components/animate'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import jsPDF from 'jspdf'
import PDFEditor from 'src/components/_dashboard/official-request/PDFEditor'

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
      cursor: 'pointer',
      display: 'flex',
      borderRadius: '6px',
      backgroundColor: '#172e34',
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0),
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative', 
      height: '100px', 
      overflow: 'hidden'
  },
  attachmentIcon: {
      marginRight: theme.spacing(1),
  },
  delete:{
      m:2,
      display:'flex',
      justifyContent:'flex-end' 
    },
  checkbox: {
      position: 'absolute',
      top: theme.spacing(1), 
      right: theme.spacing(1), 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
  },
  dialogContent: {
      padding: theme.spacing(3),
      maxWidth: 768,
      margin: 'auto',
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'center',
      alignItems: 'center',
  },
  gridContainer: {
      height: 'auto',
  },
}));

const getStatusColorAndLabel = (status, hold) => {
  switch (status) {
    case 1:
      return {
        color: hold == 1 ? 'warning' : 'info',
        label: hold == 1 ? 'Status: Hold' : 'Status: Open',
      }
    case 2:
      return {
        color: hold == 1 ? 'warning' : 'success',
        label: hold == 1 ? 'Status: Hold' : 'Status: Approved',
      } // Evaluating
    case 3:
      return {
        color: hold == 1 ? 'warning' : 'success',
        label: hold == 1 ? 'Status: Hold' : 'Status: Approved',
      }
    case 4:
      return {
        color: hold == 1 ? 'warning' : 'warning',
        label: hold == 1 ? 'Status: Hold' : 'Status: Draft',
      }
    case 5:
      return {
        color: hold == 1 ? 'warning' : 'warning',
        label: hold == 1 ? 'Status: Hold' : 'Status: Closed',
      }
    case 6:
      return {
        color: hold == 1 ? 'warning' : 'error',
        label: hold == 1 ? 'Status: Hold' : 'Status: Rejected',
      }
    default:
      return {
        color: hold == 1 ? 'warning' : 'default',
        label: hold == 1 ? 'Status: Hold' : 'Status: Open',
      }
  }
}

export default function ViewSplitEstimateDetails({
  designs,
  products,
  user,
  setDesigns,
  details,
  fetchRequestDetails,
  isRequest,
  requestId,
  signAgreements,
  customTemplate,
  questionnaireTemplate,
  allDataEmpty,
  portfolio,
  project,
  clientDetails,
  teamMembers,
  invoice,
  quotation,
  proposalView,
  isDesign,
  isFromTask,
  setRefresh,
  refresh,
  designStatus,
  selectedRecipes,
  splitServices
}) {
console.log('detailsdetails=',details)
console.log('isDesignisDesign=',isDesign)
  const fileInputRef = useRef(null)
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar()
  const {
    name,
    notes,
    description,
    services,
    start_date,
    due_date,
    status,
    reason,
    hold_reason,
    hold,
    reasonWithQb,
    estimate_id,
    added_by,
    awarded,
    rfpQbId,
    community_name,
    id,
    send_client_app_req
  } = details
  const submissionDate = moment.unix(start_date).format('MM/DD/YYYY')
  const endDate = moment.unix(due_date).format('MM/DD/YYYY')
  const xs = useMediaQuery(theme.breakpoints.down('xs'))
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const [progress, setProgress] = useState(false)
  const [modalClose, setModalClose] = useState(false)
  const [openProductModel, setOpenProductModel] = useState(false)
  const [openReasonModal, setOpenReasonModal] = useState(false)
  const [itemId, setItemId] = useState(null)
  const [reasonText, setReasonText] = useState('')
  const [openImageModal,setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const classes = useStyles();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [activeTab, setActiveTab] = useState('designs');
  const [openPDFEditor, setOpenPDFEditor] = useState(false);
  const [selectedPDFForEdit, setSelectedPDFForEdit] = useState(null);

  const approvedDesigns = designs?.filter(item=>item.approved == 1)
  const isClient = user?.isClient;
  let userType = isClient ? 3 : user?.user_type;
  let userId = user.user_id

  // Memoized calculations for costs
  const productCost = useMemo(() => {
    if (!selectedRecipes || selectedRecipes.length === 0) return 0;
    
    return selectedRecipes.reduce((total, data) => {
      const expectedCost = data?.expected_cost || 0;
      const splitAmount = expectedCost * (data?.split_percentage / 100);
      const productCost = parseFloat((expectedCost + splitAmount).toFixed(2));
      return total + productCost;
    }, 0);
  }, [selectedRecipes]);

  const installCost = useMemo(() => {
    if (!selectedRecipes || selectedRecipes.length === 0) return 0;
    
    return selectedRecipes.reduce((total, data) => {
      const installCost = data?.expected_install_labor_cost || 0;
      return total + installCost;
    }, 0);
  }, [selectedRecipes]);

  const serviceCost = useMemo(() => {
    if (!splitServices || splitServices.length === 0) return 0;
    
    return splitServices.reduce((total, service) => {
      return total + (service.total || 0);
    }, 0);
  }, [splitServices]);

  const totalCost = useMemo(() => {
    return productCost + installCost + serviceCost;
  }, [productCost, installCost, serviceCost]);

  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType =3 //user.parent_user_type
  }

  console.log("detailsdetails",invoice);
  const handleUpdateDesign = (data) => { 
    setModalClose(true)
    data.requestId = details.id
    data.userId = user.user_id
    if (data.approved) data.approved_by = user.user_id
    if(data.approved === 0 && reasonText === ''){
      enqueueSnackbar('Please add Reason', { variant: 'error' })
      return
    }
    let productName = ''
    if (data?.hasOwnProperty('product_name')) {
      productName = data?.product_name
      delete data?.product_name;
    }

    axios
      .post(`${REST_API_END_POINT}request/update-designs`, data)
      .then((res) => {
        if (res.data.status === 1) {
          enqueueSnackbar(data.approved === 1 ? 'Design has been Approved' : data.product_id ? `Design has been linked with ${productName}` : data?.status==0 ? 'Design has been Deleted' : 'Design has been Rejected', { variant: 'success' })
          fetchRequestDetails()
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
        setItemId(null)
        setModalClose(false)
        setOpenProductModel(false)
        setOpenReasonModal(false)
        setReasonText('')
      })
  }
  const handleDeleteDesign = (data) => { 
    axios
      .post(`${REST_API_END_POINT}design/delete-design`, data)
      .then((res) => {
        if (res.data.status === 1) {
          enqueueSnackbar('Design has been Deleted' , { variant: 'success' })
          setRefresh(!refresh)
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
          setRefresh(!refresh)
        }
      })
  }

  const handleDownloadEditedPdf = async (attachmentId) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-attachment-images`,
        { attachmentId, documentSource: 'split_estimate' }
      );

      const images = res.data?.images;

      if (!images || !images.length) {
        enqueueSnackbar('No edited pages available to download', { variant: 'error' });
        return;
      }

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'a4',
      });

      const pdfPageWidth = pdf.internal.pageSize.getWidth();
      const pdfPageHeight = pdf.internal.pageSize.getHeight();

      for (let i = 0; i < images.length; i++) {
        const image = images[i];

        const baseUrl = REST_API.endsWith('/')
          ? REST_API
          : `${REST_API}/`;

        const imagePath = (image.image_url || '').startsWith('/')
          ? image.image_url.slice(1)
          : image.image_url;

        const imageUrl = `${baseUrl}uploads/${imagePath}`;

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageUrl;

        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = () =>
            reject(new Error(`Failed to load image: ${imageUrl}`));
        });

        const scale = 4;

        const aspectRatio = img.height / img.width;
        const renderWidth = pdfPageWidth;
        const renderHeight = renderWidth * aspectRatio;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = renderWidth * scale;
        canvas.height = renderHeight * scale;

        ctx.scale(scale, scale);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(img, 0, 0, renderWidth, renderHeight);

        const imgData = canvas.toDataURL('image/png', 1.0);

        if (i !== 0) pdf.addPage();

        const calculatedHeight = pdfPageWidth * aspectRatio;
        const finalHeight =
          calculatedHeight > pdfPageHeight
            ? pdfPageHeight
            : calculatedHeight;

        const finalWidth = finalHeight / aspectRatio;

        pdf.addImage(
          imgData,
          'PNG',
          0,
          0,
          finalWidth,
          finalHeight,
          undefined,
          'FAST'
        );
      }

      pdf.save('edited_document.pdf');
      enqueueSnackbar('PDF downloaded successfully', {
        variant: 'success',
      });
    } catch (error) {
      console.error('Failed to download edited PDF', error);
      enqueueSnackbar(
        error?.message || 'Unable to download edited PDF',
        { variant: 'error' }
      );
    }
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0]
    const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
    const Filename = new Date().getTime() + file?.name

    // const isImage = file?.type?.startsWith('image/');
    // const isPdf = file?.type === 'application/pdf';
    const isImage = 
      file?.type?.startsWith('image/') || 
      file?.type === 'img' || 
      file?.type === 'image' ||
      fileExtension === 'png' ||
      fileExtension === 'jpg' ||
      fileExtension === 'jpeg' ||
      fileExtension === 'gif' ||
      fileExtension === 'bmp' ||
      fileExtension === 'webp' ||
      fileExtension === 'svg';
    const isPdf = 
      file?.type === 'application/pdf' || 
      file?.type === "other" || 
      file?.type === "pdf" ||
      fileExtension === 'pdf';

    if (!isImage && !isPdf){
      enqueueSnackbar('Please select a valid file. Only Images and PDF are allowed', { variant: 'error' })
      return;
    }
    const StorageRef = imageref(storage, Filename)
    const uploadTask = uploadBytesResumable(StorageRef, file)

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const pro = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        )
        setProgress(true)
      },
      (error) => {
        console.error(error.message)
        setProgress(false)
        enqueueSnackbar('Please upload Image or PDF less than 1 GB', { variant: 'error' });
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

          const uploaded = [downloadURL]
          const requestId = details.id
          const data = { requestId, userId: user.user_id, uploaded, type:file.type, size:file.size, extension:fileExtension }
          axios
            .post(`${REST_API_END_POINT}request/upload-designs`, data)
            .then((res) => {
              if (res.data.status === 1) {
                setDesigns((pv) => [
                  ...pv,
                  ...res.data.data.map((d) => ({
                    ...d,
                    updated_by: user.person_name,
                  })),
                ])
                enqueueSnackbar(res.data.message, { variant: 'success' })
              } else {
                enqueueSnackbar(res.data.message, { variant: 'error' })
              }
            })
          setProgress(false)
          fetchRequestDetails()
        })
      },
    )
  }
  const approvedCount = designs?.filter(item => item.approved === 1)?.length;
  const rejectedCount = designs?.filter(item => item.approved === 0)?.length;
  
  let borderColor = "GrayText";
  // let borderColor = theme.palette.text.secondary;
  
  // if (rejectedCount > 0) {
  //   borderColor = theme.palette.error.main;
  // } else {
  //   borderColor = theme.palette.success.main;
  // }

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpenImageModal(true);
  };

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex));
  };
  


  const filteredDesigns = details?.send_client_app_req === 1
  ? designs?.filter((item) =>
      activeTab === 'designs' ? item.isDesign === 1 : item.isDesign !== 1
    )
  : userType == 3 ? approvedDesigns : designs;

  const imageDesigns = filteredDesigns?.filter(
    (item) => item.file_type?.startsWith('image/') || item.file_type === 'img' || item.file_type === 'image'
  );
  
  return (
    <Card>
      <Stack sx={{ m: 3 }} spacing={3}>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Typography variant="overline" sx={{ color: '#ffffff' }}>
            {name}
            {/* {sentenceCase(name)} */}
          </Typography>
          <Stack direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}>
          {isFromTask ?
           <Typography fontWeight={'0.09rem'} variant="overline">
              <Label
                sx={{ p: '12px' }}
                variant={
                  theme.palette.mode === 'light' ? 'ghost' : 'filled'
                }
                color={
                  getStatusColorAndLabel(details?.status, details?.hold)
                    .color
                }
              >
                {
                  getStatusColorAndLabel(details?.status, details?.hold)
                    .label
                }
              </Label>
            </Typography>
          : ''}
          <Stack display={'flex'} direction={'column'} gap={1}>

          { details?.status ==3 && details?.reason &&
            <Typography variant="subtitle2" sx={{ color:theme.palette.error.main,maxWidth:400,overflowWrap: 'break-word',}}>
            {`Reject Reason : ${reason}`}
            </Typography>
          }
          {hold === 1 &&
            <Typography variant="subtitle2" sx={{ color:theme.palette.error.main,maxWidth:400,overflowWrap: 'break-word',whiteSpace: 'pre-line', }}>
            {hold_reason ? `Hold Reason: ${hold_reason}` : ""}
            </Typography>
          }
          </Stack>
        </Stack>
        </Stack>
        {/* {(added_by == 1 && user.user_type!=3) &&
        <Typography variant="subtitle2" sx={{ color: `${(proposalView ? !rfpQbId : (reasonWithQb || !estimate_id)) ? 'red' :'green'}` }}>
          {(proposalView && awarded == null) ? '' : 
          (proposalView ? 
          	(reasonWithQb 
            ? reasonWithQb.split('\n').map((line, index) => (
              <span key={index} style={{ display: 'block' }}>{line}</span>
            )) 
            : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...')
           :
          (estimate_id 
            ? 'Successfully Synced With QuickBooks' 
            : (reasonWithQb 
              ? reasonWithQb.split('\n').map((line, index) => (
                <span key={index} style={{ display: 'block' }}>{line}</span>
              )) 
              : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...')))}
          </Typography>} */}
        <Stack
          direction={{ xs: 'column', sm: 'row',md:'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        > 
          <Box sx={{width:'60%'}}>
          <Typography variant="overline" sx={{ color: '#ffffff' }}>
            <strong>Order Id :</strong> #{id}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Created At : </strong>  
            {details?.created_at
            ? moment(details.created_at * 1000).format('MM-DD-YYYY')
            : '—'}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Split Estimate Name :</strong> {clientDetails?.name}
          </Typography>
        
          </Box>
          {/* <Box sx={{ width: '35%' }}>
            {!user.isVendor && (
              <Stack spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CalendarToday sx={{ color: '#ffffff' }} />
                  <Typography variant="overline" sx={{ color: '#ffffff', fontWeight: 'bold' }}>
                    Requested Start Date:
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    {submissionDate}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Event sx={{ color: '#ffffff' }} />
                  <Typography variant="overline" sx={{ color: '#ffffff', fontWeight: 'bold' }}>
                    Due Date:
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    {endDate}
                  </Typography>
                </Box>
              </Stack>
            )}
            <>
              <Typography alignItems={'center'} variant="subtitle1" sx={{ mt: 2 }}>
                Designers List
              </Typography>
              <Scrollbar sx={{ width: '100%', height: 100, mt: 1.5 }}>
                <Stack>
                  {details?.projectMembers?.map((row, index) => (
                    <Stack
                      key={index}
                      direction='row'
                      mb={1}
                      spacing={1.5}
                      alignItems='center'
                    >
                      <Avatar src={row?.profile_pic} alt={row?.name} />
                      <Typography variant="subtitle2">
                        {row?.name}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Scrollbar>
            </>
          </Box> */}
        </Stack>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Box sx={{width:'80%'}}>
            <Stack sx={{flexDirection:'row'}}>
            <Tooltip title='Description'>
              <Description />
            </Tooltip>
            <Typography variant="body2" sx={{ color: '#ffffff', flexWrap:'wrap', ml:2, whiteSpace: 'pre-line' }}>
              {description} 
            </Typography>
            </Stack>
          </Box>
        </Stack>
        <Typography variant="h6" align="left"> { selectedRecipes && selectedRecipes.length > 0 ? "Product Formulas" : ""}</Typography>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          spacing={{ xs: 3, sm: 2 }}
        >
                      { selectedRecipes && selectedRecipes.length > 0 ? (
                            <>
                          <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Product</TableCell>
                                  <TableCell>Formula</TableCell>
                                  <TableCell align="center">Outgoing Percentage</TableCell>
                                  <TableCell align="center">Actual Cost</TableCell>
                                  <TableCell align="center">
                                    <Tooltip title="Actual Cost + Outgoing Percentage" arrow>
                                      <Typography variant="subtitle2">Split Retail Cost</Typography>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Tooltip title="Product Cost + Install Cost" arrow>
                                      <Typography variant="subtitle2">Total Cost</Typography>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedRecipes.map((data, index) => {
                                  data.name = data?.name || data?.recipe_name
                                  data.recipe_id = data?.recipe_id
                                  const expectedCost = data?.expected_cost || 0;
                                  let expectedCostWithoutInstallLaborCost = expectedCost;
                                  const splitAmount = expectedCostWithoutInstallLaborCost * (data?.split_percentage / 100);
                                  const totalCost = parseFloat((expectedCost + splitAmount + (data?.expected_install_labor_cost || 0)).toFixed(2));
                                  const expectedCostWithInstallLaborCost = expectedCost + (data?.expected_install_labor_cost || 0);
                                  const lineTotalwithoutInstall = parseFloat((expectedCost + splitAmount).toFixed(2));
                                  return (
                                    <>
                                      <TableRow key={index}>
                                        <TableCell >{data?.product_name || '-'}</TableCell>
                                        <TableCell>
                                        <Tooltip title={data?.name} arrow>
                                              <Typography variant="body2" sx={{ 
                                                maxWidth: 200, 
                                                overflow: 'hidden', 
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                              }}>
                                                {data?.name?.length > 30 ? `${data?.name?.substring(0, 30)}...` : data?.name || '-'}
                                              </Typography>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell align="center">
                                          <Typography variant="body2">
                                          {data?.split_percentage || 0}%
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                          <Typography variant="body2">
                                            {(expectedCost).toFixed(2)}
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                          {/* {data?.expected_install_labor_cost == null || data?.expected_install_labor_cost <= 0 ? */}
                                          <Tooltip title={`${expectedCost.toFixed(2)} + ${splitAmount.toFixed(2)} = ${lineTotalwithoutInstall?.toFixed(2)}`} arrow>
                                            <Typography variant="body2">
                                              ${lineTotalwithoutInstall?.toFixed(2)}
                                            </Typography>
                                          </Tooltip>
                                          {/* :'-'} */}
                                        </TableCell>
                                        <TableCell align="center">
                                          {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 ? (
                                            <Typography variant="body2">
                                              -
                                            </Typography>
                                          ) : (
                                            <Typography variant="body2">
                                              ${totalCost.toFixed(2)}
                                            </Typography>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                      {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 ? (
                                        <TableRow key={`install-${index}`}>
                                          <TableCell>-</TableCell>
                                          <TableCell>
                                            <Typography variant="body2" sx={{color: "#1ccaff"}}>Install Labor Cost</Typography>
                                          </TableCell>
                                          <TableCell align="center">-</TableCell>
                                          <TableCell align="center">
                                            <Typography variant="body2">
                                              {data?.expected_install_labor_cost.toFixed(2)}
                                            </Typography>
                                          </TableCell>
                                          <TableCell align="center">
                                            <Typography variant="body2">
                                              {data?.expected_install_labor_cost.toFixed(2)}
                                            </Typography>
                                          </TableCell>
                                          <TableCell align="center">
                                            <Typography variant="body2">
                                              ${totalCost.toFixed(2)}
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      ):''}
                                      <TableRow>
                                        <TableCell colSpan={6} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  )})}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        
                         </>
                         ) : 
                          ""
                         }
            </Stack>
            
            {/* Split Services Table */}
            {splitServices && splitServices.length > 0 ? (
              <>
                <Typography variant="h6" align="left" sx={{ mt: 3 }}>Split Services</Typography>
                <TableContainer component={Paper} sx={{ mt: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Service Name</TableCell>
                        <TableCell align="center">Unit Cost</TableCell>
                        <TableCell align="center">Quantity</TableCell>
                        <TableCell align="center">Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {splitServices.map((service, index) => (
                        <TableRow key={index}>
                          <TableCell>{service.name || '-'}</TableCell>
                          <TableCell align="center">
                            <Typography variant="body2">
                              ${(service.unit_cost || 0).toFixed(2)}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body2">
                              {service.quantity || 0}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body2">
                              ${(service.total || 0).toFixed(2)}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ):''}
            {selectedRecipes && selectedRecipes.length > 0 ? (
              <Box sx={{ mb: 2,marginRight:2 }}>
                <Grid container spacing={1} sx={{ maxWidth: 400, ml: 'auto' }}>
                  <Grid item xs={9}>
                    <Typography variant="h6" sx={{ textAlign: 'right' }}>
                      Total Product Cost :
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h6" sx={{ textAlign: 'right' }}>
                      ${productCost.toFixed(2)}
                    </Typography>
                  </Grid>
                  
                  <Grid item xs={9}>
                    <Typography variant="h6" sx={{ textAlign: 'right', pt: 1 }}>
                      Total Installation Cost :
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h6" sx={{ textAlign: 'right', pt: 1 }}>
                      ${installCost.toFixed(2)}
                    </Typography>
                  </Grid>
                  {
                    details?.isFromDesignOrder ?
                    <>
                  <Grid item xs={9}>
                    <Typography variant="h6" sx={{ textAlign: 'right',pt: 1 }}>
                      Total Service Cost :
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h6" sx={{ textAlign: 'right',pt: 1 }}>
                      ${serviceCost.toFixed(2)}
                    </Typography>
                  </Grid>
                    </>
                    :''
                  }
                  
                  <Grid item xs={9}>
                    <Typography variant="h6" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                      Grand Total Cost :
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h6" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                      ${totalCost.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            ) : (
              <Stack direction={{ xs: 'row', sm: 'row' }}
                spacing={{ xs: 3, sm: 2 }} display={'flex'} justifyContent={'flex-end'}>
                <Typography variant="h6" align="right" sx={{mr:5}}>
                  Total Cost: ${details?.total_cost}
                </Typography>
              </Stack>
            )}
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          spacing={{ xs: 3, sm: 2 }}
        >
        
        </Stack>
        {userType !==3 ? ((details?.send_client_app_req && designs?.length > 0) ? (
          <Box display="flex" justifyContent="center" mb={2} gap={2}>
            <Button
              variant={activeTab === 'designs' ? 'contained' : 'outlined'}
              onClick={() => setActiveTab('designs')}
            >
              Designs
            </Button>
            <Button
              variant={activeTab === 'files' ? 'contained' : 'outlined'}
              onClick={() => setActiveTab('files')}
            >
              Files
            </Button>
          </Box>
        ) : "") : 'Designs' }
      
        
        {/* {designs?.length ? ( */}
        {(userType === 3 ? (details?.send_client_app_req || approvedDesigns?.length > 0) : designs?.length >0) ? (
          <Box sx={{border: '0.1px solid', borderColor: borderColor,padding:2, }}>
            <Scrollbar sx={{ width: '100%', height: 450 }}>
            {filteredDesigns?.length > 0 ?
              <ImageList  
                gap={16} 
                cols={mdd ? 2 : xld ? 4 : xs ? 1 : 3}
                sx={{
                  padding: 2,
                  '& .MuiImageListItem-root': {
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }
                }}
              >
                {/* <ImageListItem key="Subheader" cols={2}> */}
                {/* </ImageListItem> */}
                {filteredDesigns?.map((item,index) =>{
                    // const { file_type, name, url } = item;
                    // const isImage = file_type?.startsWith('image/') || file_type ==='img';
                    // const isPdf = file_type === 'application/pdf';
                    const { file_type, name, url, extension, approved, reason, status } = item;
                    if (item.approved !== 1 && isClient) return;
                    const isImage = 
                      file_type?.startsWith('image/') || 
                      file_type === 'img' || 
                      file_type === 'image' ||
                      extension?.toLowerCase() === 'png' ||
                      extension?.toLowerCase() === 'jpg' ||
                      extension?.toLowerCase() === 'jpeg' ||
                      extension?.toLowerCase() === 'gif' ||
                      extension?.toLowerCase() === 'bmp' ||
                      extension?.toLowerCase() === 'webp' ||
                      extension?.toLowerCase() === 'svg';
                    const isPdf = 
                      file_type === 'application/pdf' || 
                      file_type === "other" || 
                      file_type === "pdf" ||
                      extension?.toLowerCase() === 'pdf';
                  return (
                  <ImageListItem  key={item.name} sx={{
                    cursor:'pointer',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      transition: 'transform 0.2s ease-in-out',
                    }
                  }}>
                    {/* <Stack sx={{
                      position: 'absolute',
                      zIndex: 9,
                      top: 8,
                      left: 10,
                    }}>
                      {item.approved === 1 ?(
                        <Label
                          variant={'filled'}
                          color={'success'}
                          style={{ color: 'white', height: 20, width: 100 }}
                        >
                          {'Approved'}
                        </Label>                       
                      ): 
                      item.reason ? (
                        <Label
                        variant={'filled'}
                        color={'error'}
                        style={{ color: 'white', height: 20, width: 100 }}
                        >
                        {'Rejected'}
                      </Label>
                      ):null}
                    </Stack>
                    <Stack sx={{
                      position: 'absolute',
                      zIndex: 9,
                      top: 0,
                      left: 10,
                    }}>
                      {item.approved === 1 ? (''
                        // <Typography sx={{ position: 'absolute', top: 40, zIndex: 100 }}>
                        //   <Label
                        //     variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        //     color="success"
                        //   >
                        //     <Tooltip title={item.approved_by}>
                        //       <Typography
                        //         variant="subtitle2"
                        //         sx={{
                        //           fontSize: '12px',
                        //           cursor: 'pointer',
                        //           display: 'inline-block',
                        //           maxWidth: 150, // Adjust as necessary
                        //           overflow: 'hidden',
                        //           textOverflow: 'ellipsis',
                        //           whiteSpace: 'nowrap',
                        //         }}
                        //       >
                        //         <span
                        //           style={{
                        //             overflow: 'hidden',
                        //             textOverflow: 'ellipsis',
                        //             whiteSpace: 'nowrap',
                        //           }}
                        //         >
                        //           Approved By: {item.approved_by}
                        //         </span>
                        //       </Typography>
                        //     </Tooltip>
                        //   </Label>
                        // </Typography>

                      ) : item.reason ? 
                      <Typography sx={{ position: 'absolute', top: 40, zIndex: 100 }}>
                      <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color="error"
                      >
                        <Tooltip title={item.reason}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontSize: '12px',
                              cursor: 'pointer',
                              display: 'inline-block',
                              maxWidth: 150, // Adjust as necessary
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            <span
                              style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              Rejected Reason: {item.reason}
                            </span>
                          </Typography>
                        </Tooltip>
                      </Label>
                    </Typography>
                      : ''}
                    </Stack> */}
                        {isImage ? (
                          <a
                          // href={name}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault();
                            handleImageClick(imageDesigns.findIndex((img) => img.name === name))
                          }}
                        >
                          <img
                            srcSet={`${url}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                            src={`${url}?w=240&h=240&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                            style={{ 
                              width: '100%', 
                              height: '240px', 
                              cursor: 'pointer',
                              objectFit: 'cover',
                              borderRadius: '8px 8px 0 0'
                            }}
                          />
                          </a>
                        ) : isPdf ? (
                          <Box display="flex" alignItems="center">
                          {/* PDF Icon Button */}
                          <Tooltip title='View'>
                            <IconButton 
                            onClick={() => {
                              setPdfLoading(true);
                              setSelectedPDF(url);
                              setOpenPDFModal(true);
                            }}
                              aria-label="open pdf"
                              sx={{ position:'absolute', 
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                               zIndex: 200,color:theme.palette.error.main, backgroundColor:theme.palette.text.primary }} >
                              <PictureAsPdf style={{ fontSize: 40 }} />
                            </IconButton>
                          </Tooltip>
                    
                          {/* Iframe */}
                          <iframe
                            src={url}
                            title={name}
                            style={{ 
                              width: '100%', 
                              height: '240px',
                              borderRadius: '8px 8px 0 0',
                              border: 'none'
                            }}
                            frameBorder="0"
                          />
                          <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                            <Card className={classes.dialogContent}>
                              <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => window.open(selectedPDF, '_blank')}
                                    disabled={!selectedPDF}
                                    startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                    sx={{
                                      fontSize:'14px'
                                    }}
                                  >
                                    View PDF
                                  </Button>
                              </div>
                              {pdfLoading && (
                                <Skeleton variant="rectangular" width="100%" height={500} />
                              )}

                              <iframe
                                src={selectedPDF}
                                title="Selected PDF"
                                width="100%"
                                height="500px"
                                frameBorder="0"
                                style={{ display: pdfLoading ? 'none' : 'block' }}
                                onLoad={() => setPdfLoading(false)}
                              />
                            </Card>
                          </DialogAnimate>
                        </Box>
                        ) : (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '100%',
                              height: '240px',
                              backgroundColor: theme.palette.grey[100],
                              borderRadius: '8px 8px 0 0',
                              border: `1px solid ${theme.palette.grey[300]}`
                            }}
                          >
                            <Typography 
                              sx={{
                                color: theme.palette.error.main,
                                textAlign: 'center'
                              }}
                            >
                              Unsupported file type
                            </Typography>
                          </Box>
                        )}
                    <ImageListItemBar
                      sx={{
                        width: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        color: 'white',
                        borderRadius: '0 0 8px 8px',
                      }}
                      subtitle={
                        isPdf ? (
                          <Stack direction="column" alignItems="flex-start">
                            <Typography variant="caption" sx={{ mb: 0.5 }}>
                              {moment.unix(item.timestamp).format('MM/DD/YYYY')}
                            </Typography>
                            <Accordion
                              elevation={0}
                              sx={{
                                bgcolor: 'transparent',
                                pr: 1.5,
                                '&:before': { display: 'none' },
                                color: 'inherit',
                                width: '100%',
                                m: 0,
                                '&.Mui-expanded': { m: 0 },
                              }}
                            >
                              <AccordionSummary
                                expandIcon={
                                  <ExpandMoreIcon sx={{ fontSize: 18, color: 'inherit' }} />
                                }
                                sx={{
                                  minHeight: '18px',
                                  px: 0,
                                  '&.Mui-expanded': { minHeight: '18px' },
                                  '& .MuiAccordionSummary-content': { margin: 0 },
                                  '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
                                }}
                              >
                                <Typography variant="caption">Edit PDF</Typography>
                              </AccordionSummary>
                              <AccordionDetails sx={{ p: 0, pt: 1, pb: 0.5 }}>
                                <Stack direction="row" width="100%" spacing={1} sx={{ flexDirection: 'row' }}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={() => {
                                      setSelectedPDFForEdit({ url: url || name, item });
                                      setOpenPDFEditor(true);
                                    }}
                                    startIcon={<EditIcon sx={{ fontSize: 11 }} />}
                                    sx={{ textTransform: 'none', boxShadow: 'none', fontSize: '11px' }}
                                  >
                                    Edit
                                  </Button>
                                  {/* <Button
                                    size="small"
                                    variant="outlined"
                                    color="inherit"
                                    onClick={() => handleDownloadEditedPdf(item.id)}
                                    sx={{ textTransform: 'none', fontSize: '11px' }}
                                  >
                                    Download Edited PDF
                                  </Button> */}
                                </Stack>
                              </AccordionDetails>
                            </Accordion>
                          </Stack>
                        ) : (
                          moment.unix(item.timestamp).format('MM/DD/YYYY')
                        )
                      }
                      // actionIcon={
                      //    <>                       
                      //    {!user.isVendor&& !project&&(
                      //   <UserMoreMenu
                      //     common={{
                      //       name: (item?.approved !== 1 && item?.product_id !== null) && 'Approve',
                      //       function:
                      //       (item?.approved !== 1 && item?.product_id !== null) ? () => {
                      //         setItemId(item.id)
                      //         setModalClose(true)
                      //         handleUpdateDesign({
                      //           id: item.id,
                      //           // product_id: product.product_id,
                      //           approved: 1,
                      //           reason:null
                      //         })
                      //         // setOpenProductModel(true)
                      //       } : null ,
                      //       Iccon:
                      //       (item?.approved !== 1 && item?.product_id !== null) && (
                      //           <ThumbUpAltOutlined />
                      //         ),
                      //       modalClose: modalClose,
                      //     }}
                      //     linkImageWithTask={{
                      //       name: item?.product_id == null && 'Link with catalog',
                      //       function:
                      //       item?.product_id == null ? () => {
                                    
                      //               setItemId(item.id)
                      //               setModalClose(true)
                      //               setOpenProductModel(true)
                      //             } : null ,
                      //       Iccon: item?.product_id == null && (
                      //           <Link />
                      //         ),
                      //       modalClose: modalClose,
                      //     }}

                      //     common2={{
                      //       name: (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && 'Reject',
                      //       function:
                      //       (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) ? () => {
                      //                 setItemId(item.id)
                      //                 setOpenReasonModal(true)
                      //             } : null ,
                      //       Iccon:
                      //       (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && (
                      //           <ThumbDownOffAltOutlined />
                      //         )
                      //         ,
                      //       modalClose: modalClose,
                      //     }}
                      //     //   onDelete={() => handleUpdateDesign({ id: item.id, status: 0 })}
                      //     {...(item.approved === 1
                      //       ? {}
                      //       : {
                      //           onDelete: () =>
                      //             handleUpdateDesign({
                      //               id: item.id,
                      //               status: 0,
                      //             }),
                      //         })}
                      //   />
                      //   )}                          
                      //   </>
                      // }
                      actionIcon={
                          <>
                            {!user.isVendor && !project && (designStatus !==2 && send_client_app_req === 0 || designStatus ===6 || item?.isDesign === 2) && (
                              <UserMoreMenu
                                {...{
                                  onDelete: () =>
                                    handleDeleteDesign({
                                      id: item.id,
                                      userId: user?.user_id
                                    }),
                                }}
                              />
                            )}
                          </>
                        }
                    />
                    {openProductModel && itemId === item.id && <Card sx={{ position:'absolute', zIndex: 10, bottom: 5,left: 5,p: 2}}>
                      <Stack direction={'row'} justifyContent={'space-between'}>
                      <Typography marginBottom={2} variant='subtitle2'>Choose Product</Typography>
                      <CancelOutlined sx={{ cursor: 'pointer' }} onClick={()=>{
                        setModalClose(false)
                        setOpenProductModel(false)
                        }}/>
                      </Stack>
                      <Divider sx={{ marginBottom: 2}}/>
                    <Stack spacing={1}>
                      {
                        products?.filter((prodItem)=>prodItem?.material===0 && prodItem?.rfp===0)?.map((product) => 
                          <><Typography sx={{ cursor: 'pointer' }} variant='caption' onClick={()=>handleUpdateDesign({
                                    id: item.id,
                                    product_id: product.product_id,
                                    product_name: product.product_name,
                                    // approved: 1,
                                    reason:null
                                  })}>{product.product_name}</Typography>
                                  <Divider/>
                                  </>
                        )
                      }
                      </Stack>
                    </Card>}
                    
                    <Modal
                        open={openReasonModal && itemId === item.id}
                        handleClose={() => {
                          setOpenReasonModal(false)
                        }}
                        modalTitle={`Reason for Design Rejection`}
                      >
                        
                            <Grid container justifyContent="center" alignItems="center">
                              <Grid item xs={12} >
                                <TextField
                                  fullWidth
                                  label="Reason"
                                  value={reasonText}
                                  onChange={(e) => setReasonText(e.target.value)}
                                />
                                <Box
                                  sx={{
                                    mt: 3,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: 1,
                                  }}
                                >
                                  <LoadingButton
                                    type="submit"
                                    variant="contained"
                                    onClick={()=>handleUpdateDesign({
                                      id: itemId,
                                      reason: reasonText,
                                      approved: 0,
                                    })}
                                    // loading={isSubmitting}
                                  >
                                    {' Save '}
                                  </LoadingButton>
                                  <Button
                                    variant="outlined"
                                    type="submit"
                                    onClick={() => {
                                      setOpenReasonModal(false)
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </Box>
                              </Grid>
                            </Grid>
                      </Modal>
                  </ImageListItem>
                   )
                   })}
              </ImageList>
            : 
              <Stack alignItems={'center'} justifyContent={'center'} >
                <Typography>
                  {activeTab === 'files' ? 'No Files Found' : 'No Designs Found'}
                </Typography>
              </Stack>
            }
            </Scrollbar>
          </Box>
        ) : (
          ''
        )}
      </Stack>
      <Modal width={1000}
              open={openImageModal}
              handleClose={() => {
                setOpenImageModal(false);
              }}
              modalTitle={'Designs'}
              >
              <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                gap:'1rem',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
            <IconButton
              onClick={handlePrevious}
              disabled={currentImageIndex === 0}
              sx={{
                opacity: currentImageIndex === 0 ? 0.3 : 1,
                pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowLeftOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>

            <Box
            component={'div'} 
              style={{
                width: '500px',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow: 'hidden',
              }}
            >
              <img
                src={imageDesigns[currentImageIndex]?.url}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
            </Box>
            <IconButton
              onClick={handleNext}
              disabled={currentImageIndex === imageDesigns.length - 1}
              sx={{
                opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
                pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowRightOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>
          </div>
        </Modal>
      {/* {(user.isVendor === null || user.isVendor === 0) &&(
      <AccountNotifications
                  isRequest={true}
                  requestId={requestId}
                 signAgreements={signAgreements}
                 customTemplate={customTemplate}
                 questionnaireTemplate={questionnaireTemplate}
                 allDataEmpty={allDataEmpty}
                 portfolio={portfolio}
                 updatingFunction={fetchRequestDetails}/>
                 )} */}
      {selectedPDFForEdit && (
        <PDFEditor
          open={openPDFEditor}
          onClose={() => {
            setOpenPDFEditor(false);
            setSelectedPDFForEdit(null);
          }}
          pdfUrl={selectedPDFForEdit.url}
          attachmentId={selectedPDFForEdit.item?.id}
          requestId={requestId}
          onSaveSuccess={fetchRequestDetails}
          documentSource="split_estimate"
        />
      )}
      </Card>
    )
  }